import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propNumber } from '../../../../helpers/custom-prop-types';
import PictureFrameIcon from '../../../Icon/Svg/PictureFrameIcon';
import Hover from '../../../Ui/System/Hover';
const SlideSearchTopMySlideListItemUploading = (props) => {
    const { progress } = props;
    return (_jsx(Hover, { children: _jsx("div", Object.assign({ className: 'slide_list_link' }, { children: _jsxs("div", Object.assign({ className: 'slide_list_inner' }, { children: [_jsx(PictureFrameIcon, {}), _jsx("p", Object.assign({ className: 'slide_list_inner_text' }, { children: "\u30B9\u30E9\u30A4\u30C9\u3092\u30A2\u30C3\u30D7\u3057\u3066\u3044\u307E\u3059\u2026" })), _jsx("div", Object.assign({ className: 'slide_list_inner_anim' }, { children: _jsx("span", { className: `slide_list_inner_anim_inner is-percentage-${progress}` }) }))] })) })) }));
};
SlideSearchTopMySlideListItemUploading.propTypes = {
    progress: propNumber(),
};
SlideSearchTopMySlideListItemUploading.defaultProps = {
    progress: 0,
};
export default SlideSearchTopMySlideListItemUploading;
